import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { WEB_ROUTES } from "../../constants";
import CourseComponent from "../Courses/CourseComponent";
import DashboardCard from "./DashboardCard";
import _ from "lodash";
import { Spinner } from "react-bootstrap";
import EmptyContainer from "../../Components/Container/EmptyContainer";
import { useEnrollTrainingMutation } from "../../Data/services/trainingApi";
import Toast, { SuccessToast } from "../../Hooks/useToast";

const Recommendations = ({ data = [], loading, refetch }) => {
  const navigate = useNavigate();

  const [enrollingId, setEnrollingId] = useState(undefined);

  const [enrollTraining, { isError, isLoading, isSuccess }] = useEnrollTrainingMutation();

  const handleEnroll = async (triningId) => {
    setEnrollingId(triningId)
    const data = {
      training_id: triningId,
    }

    try {
      const response = await enrollTraining(data);

      // console.log(response.error.status);
      console.log(response);

      if (response.error && response.error.status >= 400) {
        const message = await response.error.data.message;
        Toast(`${message}`, "error");
        // console.log(message)
      }

      if (!response.error && response.data.code === 200) {
        refetch();
        SuccessToast(response?.data?.message);

      }
    } catch (error) {
      console.log(error);
      if (error?.response && error?.response?.data?.message) {
        Toast(error?.response?.data?.message, "error");
      } else {
        Toast("An error occurred during login", "error");
      }
    }
    finally {
      setEnrollingId(undefined)
    }
  }

  return (
    <div>
      <DashboardCard heading={"Recommended for you"}>
        <div className="scrollable">
          {
            loading ? (
              <div className="w-100 d-flex flex-row justify-content-center">
                <Spinner />
              </div>
            ) : _.isEmpty(data) ?
              <EmptyContainer text="Data Not Found" classes="my-2" />
              : (
                data?.map((item, index) => {
                  return (
                    <div className="my-3 ">
                      <CourseComponent
                        key={_.uniqueId()}
                        // image={`/images/Orthopaedics.png`}
                        image={item.image_url}
                        title={item.name}
                        description={item.description}
                        enrollStatus={item.is_enrolled}
                        trainingId={item.id}
                        handleEnroll={handleEnroll}
                        isEnrolling={isLoading && (enrollingId == item.id)}
                        onSelect={(e, index) => {
                          // console.log(item.id);
                          navigate(`/${WEB_ROUTES.BATCHES}`, {
                            state: {
                              item: {
                                id: item.id,
                                title: item.name,
                                image_url: item.image_url,
                                is_enrolled: item.is_enrolled
                              },
                            },
                          });
                        }}
                      />
                    </div>
                  );
                })
              )}
        </div>
      </DashboardCard>
    </div>
  );
};

export default Recommendations;
